import React, { useState } from "react";
import styles from "../Casefile.module.scss";
import CloseButton from "./CloseButton";
import { Link } from "@reach/router";

function Horse(props) {
  const [bacteriaNo, setBacteriaNo] = React.useState(0);

  if (bacteriaNo === 0) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>"Neigh there fellow Mammal!</p>
          <p>
            Welcome to this urban farm I live in! They call this area Rice
            Lane...
          </p>
          <p>
            I guess the Fox has sent you to hear our stories so we can win the
            Non-Human
          </p>{" "}
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(1);
              }}
            >
              Tournament
            </button>
          </p>{" "}
          <p>right?</p>
          <p>There are other Mammals like</p>{" "}
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(6);
              }}
            >
              cows
            </button>
          </p>
          <p> and</p>{" "}
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(5);
              }}
            >
              pigs
            </button>
          </p>{" "}
          <p>do you want me to take you to them?"</p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 1) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            "Neigh there's a Non-Human Tournament going on in Liverpool! Only
            one Folk can win. We get points by telling our problems and thoughts
            about living in the city as a Non-Human...
          </p>

          <p>
            {" "}
            If we do it right, we get points, and if we get points... WE MAY GET
            UNIQUE LAWS TO PROTECT OUR FOLK!! We really need to win!"
          </p>
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(2);
              }}
            >
              {" "}
              Talk to Small Pig
            </button>
          </p>
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(3);
              }}
            >
              {" "}
              Talk to the Cows
            </button>
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 2) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          {" "}
          <p>
            ""Hey buddy! My name Sausage but I prefer to be called Frank as
            Sausage is a bit too explicit. I like to take mud baths and I hope
            that a human will come and make me into Sausages... Mmmmmm what a
            nice sausage I could become!"
          </p>
          <p>
            Perhaps you could Write an Incident Marker about Pig's Mental
            Health?
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 3) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            "Mooooooo, we're busy cows. Leave us alone, can't you see we're busy
            providing milk for the humans? This is a very private moment, and we
            have enough being exposed to humans all the time!"
          </p>
          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(4);
              }}
            >
              Investigate the rest of the Farm
            </button>
          </p>
          <p>Or perhaps you could write an Incident Marker about Cows?</p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 4) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            "Well friend the rest of the farm is where the Cabbage, the Carrots
            and Apples I dream about live! I try and eat as many as I can so
            they cannot write Incident Markers and we win the{" "}
          </p>
          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(1);
              }}
            >
              Tournament!
            </button>
          </p>

          <p>Cheeky that, I know. But rules are made to be broken!"</p>

          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(6);
              }}
            >
              Talk to the Cows
            </button>
          </p>
          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(5);
              }}
            >
              Talk to the Pigs
            </button>
          </p>
          <p>
            Or perhaps you're ready to write an Incident Marker about the
            animals in the farm!
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 5) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            "Hi there! My name's Hamlet and I live in fear of someone coming to
            get HAM from me!!!!!
          </p>
          <p>
            And oh boi does Hamlet not like HAM! Would you help me write an
            Incident Marker to tell my story please matey!"
          </p>
          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(2);
              }}
            >
              Talk to Small Pig
            </button>
          </p>
          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(4);
              }}
            >
              Investigate the rest of the Farm
            </button>
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 6) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            "Well you wanted to meet the Cows. Here are Bessy Daisy Rose and
            Auty May, the craziest Cows in town! They will give you enough
            material for 100 Incident Markers!"
          </p>
          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(3);
              }}
            >
              Talk to the Cows
            </button>
          </p>

          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(4);
              }}
            >
              Investigate the rest of the Farm
            </button>
          </p>
        </div>
      </div>
    );
  }
}

export default Horse;
